import {Injectable} from '@angular/core';
import {Headers, Http, Response} from '@angular/http';
import 'rxjs/add/operator/toPromise';
import {webapi} from '../../shared/my-constants';

@Injectable()
export class TrnServiceCabinScheduleService {
  mstDay: any;
  private headers = new Headers({'Content-Type': 'application/json'});
  private ListRecord = webapi + 'trn_service_cabin_schedule/list/?';
  private AddRecord = webapi + 'trn_service_cabin_schedule/create';
  private EditRecord = webapi + 'trn_service_cabin_schedule/update';
  private GetRecord = webapi + 'trn_service_cabin_schedule/byid/';
  private DeleteRecord = webapi + 'trn_service_cabin_schedule/delete/';
  private GetTokenDisplayForAllStaff = webapi + 'trn_service_cabin_schedule/gettokendisplayforallstaff/';
  private GetTokenDisplayForOncology = webapi + 'trn_service_cabin_schedule/gettokendisplayforoncology/';
  private GetTokenDisplayByUnitId = webapi + 'trn_service_cabin_schedule/getTokenDisplayByUnitId/';
  private GetRecordServiceId = webapi + 'trn_service_cabin_schedule/getRecordServiceId/';
  private GetTokenDisplayByDoctorList = webapi + 'trn_service_cabin_schedule/get_token_by_doctor_list/';
    private GetTokenDisplayBySubDeparmentId = webapi + 'trn_service_cabin_schedule/getTokenDisplayBySdId';


  constructor(
    private http: Http
  ) {
  }

  getAllRecordService(currentPage: any, size: any, qString: any, sort: any, col: any): Promise<any> {
    return this.http.get(this.ListRecord + 'page=' + currentPage + '&size=' + size + '&qString=' + '' + '&sort=' + sort + '&col=' + col)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  addRecordService(model: any) {
    return this.http.post(this.AddRecord, JSON.stringify(model), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  editRecordService(model: any) {
    return this.http.put(this.EditRecord, JSON.stringify(model), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  deleteRecordService(id: any) {
    return this.http.put(this.DeleteRecord + id, {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getRecordService(id: any) {
    return this.http.get(this.GetRecord + id)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getTokenDisplayForAllStaff(): Promise<any> {
    return this.http.get(this.GetTokenDisplayForAllStaff)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getTokenDisplayByUnitId(id: any) {
    return this.http.get(this.GetTokenDisplayByUnitId + id)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getTokenDisplayForOncology(id: any) {
    return this.http.get(this.GetTokenDisplayForOncology + id)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getRecordServiceId(id: any) {
    return this.http.get(this.GetRecordServiceId + id)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getTokenDisplayByDoctorList(doctorList: any) {
    // console.log(this.GetTokenDisplayByDoctorList + doctorList)
    return this.http.get(this.GetTokenDisplayByDoctorList + doctorList)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

    getTokenDisplayBysdiDList(data: any) {
        return this.http.post(this.GetTokenDisplayBySubDeparmentId, JSON.stringify(data), {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }


    private handleError(error: Response | any) {
    return Promise.reject(error.message || error);
  }
}




// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/configuration/trn-service-cabin-schedule/trn-service-cabin-schedule.service.ts